export default {
  primaryColor: "#75FE00",
  primaryContainerBg: "#80FF2C",
  transparent: "rgba(255,255,255,0)",
  redText: "#FF0000",
  redError: "#B81F1E",
  black: "#000000",
  white: "#ffffff",
  amm: "#67E100",
  chartGray: "#D6D6D6",
  ammChartDot: "#67E100",
  resultChartDot: "#67E100",
  alcoholChartBar: "#75FE00",
  healthCheckSectionHeader: "#CEFFAC",
  healthCheckSectionHeaderBorder: "#E3E3DC",
  healthCheckInputBottomLine: "rgb(0,0,0, .5)",
  chartLine: "rgba(0,0,0,0.3)",
  resultLegendBorder: "#80FF2C",
};
